<template>
  <div class="pos-mode">
    <div class="columns">
      <div class="column">
        <div class="group">
          <LocalizedInput :title="$t('name')" :translate="value.name" />
        </div>
      </div>

      <div class="column">

      </div>
    </div>
  </div>
</template>

<script>
import LocalizedInput from "@/components/tools/LocalizedInput";

export default {
  name: "PosMode",
  components: {LocalizedInput},
  props: {
    value: Object
  },

  methods: {
    newElementData() {
      return {
        id: null,
        name: {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>